import script from "./DynamicContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicContent.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicContent.vue?vue&type=style&index=0&id=1878ecc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1878ecc0"]])

export default __exports__